<template>
  <div class="bg-white shadow sm:rounded-lg">

    <div v-if="!success">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Input your redeem code to receive your ticket.
        </h3>
        <div class="mt-2 max-w-xl text-sm text-gray-500">
          <div v-html="ticketType.redeem_explain"></div>
        </div>
        <div class="mt-5 sm:flex sm:items-center">
          <div class="w-full sm:max-w-xs">
            <input v-model="code" type="text"
                   class="input shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                   placeholder="Input your redeem code">
          </div>
          <button v-on:click="submit"
                  class="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
            Check Code
          </button>

        </div>
        <div class="mt-2 max-w-xl text-sm text-red-700 text-2xl">
          <p v-if="isLoading">Checking...</p>
          <p v-if="evMessage">{{ evMessage }}</p>
          <p v-if="message">{{ message }}</p>
        </div>
      </div>
    </div>
    <div v-if="success" class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Code Confirms
        </h3>
        <div class="mt-2 max-w-xl text-sm text-gray-500">
          <p>
            Now click the button to get your ticket.
          </p>
        </div>
        <div class="mt-5">
          <form :action="submitUrl" method="POST">

            <input name="code" :value="code" type="hidden">
            <input type="hidden" name="_token" :value="csrf">
            <button type="submit" class="inline-flex items-center justify-center
          px-4 py-2 border border-transparent font-medium rounded-md text-green-700 bg-green-100 hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:text-sm">
              Get Ticket
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "RedeemTicket",
  computed: {},
  props:
      {
        url: {
          type: String,
          required: true
        },
        submitUrl: {
          type: String,
          required: true
        },
        ticketType: {
          type: Object,
          required: true
        }
      },

  data() {
    return {
      code: '',
      message: '',
      evMessage: '',
      success: false,
      isLoading: false,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    }
  },

  methods: {


    submit() {

      if (!this.code) {
        this.message = 'You must enter a code';
        return;
      }

      this.message = '';
      this.evMessage = '';
      this.isLoading = true;



      const formData = new FormData();
      formData.append('code', this.code);
      formData.append('_minor', this.ticketType.price.toString());
      formData.append('_currency', this.ticketType.currency);
      formData.append('_ticket_type_id', this.ticketType.id);
      //console.log(formData);

      // https://github.com/axios/axios/issues/960
      // https://stackoverflow.com/questions/51143730/axios-posting-empty-request
      axios.post(this.url, formData)
          //axios.get(this.url+'?code='+this.code)
          .then(response => {
            //console.log(response.data);
            this.message = '';
            this.success = true;
            this.isLoading = false;
          })
          .catch(error => {

            this.isLoading = false;

            if (error.response) {
              this.message = error.response.data.message;
              if (error.response.status !== 401) {
                this.evMessage = 'An error has occurred. This is not an Eventzilla error. ';
                if (this.message) {
                  this.evMessage += 'Details are as follows:'
                } else {
                  this.evMessage += 'There are no details about this error. You should contact the conference organizers.';
                }
              } else {
                this.message = this.message ? this.message : 'It seems that this code is invalid.';
              }
            } else {
              this.evMessage = 'An error has occurred. This is not an Eventzilla error. ' +
                  'It is most likely caused by your browser/institution blocking the connection.' +
                  '(1) Try in a different browser or computer - even your mobile. ' +
                  '(2) Try in a different location. ' +
                  'Failing that you should contact the conference organizers.';
            }

          });

    },

  },

  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  beforeUnmount() {

  },
  unmounted() {

  }


};
</script>

<style scoped>
i {
  cursor: pointer;
  color: #e74444;
  font-size: 0.7em;
}
</style>